<template>
  <!-- basic modal -->
  <b-modal
    id="create-payroll-modal"
    title="Create Payrolls"
    size="md"
    :no-close-on-backdrop="true"
    cancel-variant="outline-secondary"
    cancel-title="Cancel"
    ok-title="Create"
    @show="onModalOpen"
    @hidden="resetModal"
    @ok="handleCreate"
  >
    <b-form
      ref="form"
      @submit.stop.prevent="handleSubmit"
    >
      <b-row>
        <b-col cols="12">
          <b-row
            ref="row"
          >
            <b-col md="6">
              <b-form-group
                label="Start"
                label-for="start"
              >
                <flat-pickr
                  v-model="fromStr"
                  class="form-control"
                  :config="{ time_24hr: true }"
                  @on-change="(date) => { setDate(date, 'start') }"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="End"
                label-for="end"
              >
                <flat-pickr
                  v-model="toStr"
                  class="form-control"
                  :config="{ minDate: from, time_24hr: true }"
                  @on-change="(date) => { setDate(date, 'end') }"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-col cols="12">
            <hr>
          </b-col>
        </b-col>
      </b-row>
      <b-row v-if="users.length > 1">
        <b-col
          md="2"
        >
          <b-form-checkbox
            v-model="allSelected"
            switch
            inline
            @change="checkBoxChecked"
          />
        </b-col>
        <b-col
          md="6"
        >
          <p style="text-transform: capitalize">
            Select All
          </p>
        </b-col>
      </b-row>
      <b-row
        v-for="(item, index) in users"
        :key="index"
      >
        <b-col
          md="2"
        >
          <b-form-checkbox
            v-model="item.selected"
            switch
            inline
          />
        </b-col>
        <b-col
          md="6"
        >
          <p
            class="d-flex justify-content-between"
            style="text-transform: capitalize"
          >
            {{ item.fullName }}
            <b-badge
              v-if="item.isUserNew"
              pill
              variant="light-info"
            >
              Uusi
            </b-badge>
          </p>
        </b-col>
        <b-col
          md="3"
        >
          <p>
            {{ item.shifts.length }} vuoroa
          </p>
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
</template>

<script>
import {
  BModal, BRow, BCol, BFormGroup, BForm, BBadge,
  BFormCheckbox,
} from 'bootstrap-vue'
// import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import {
  createPayrolls, savePayrolls, fetchShifts, fetchUser, isUserNewToPayroll,
} from '@/shared/services/payrollService'

export default {
  components: {
    BModal,
    BRow,
    BCol,
    BFormGroup,
    BForm,
    BFormCheckbox,
    BBadge,
    // vSelect,
    flatPickr,
  },
  directives: {
    Ripple,
  },
  props: {
    editGig: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isQuickShift: true,
      users: [],
      required,
      from: null,
      to: null,
      allSelected: true,
      fromStr: '',
      toStr: '',
    }
  },
  watch: {
    template(newVal) {
      if (newVal) {
        this.form.location = newVal.value.location
        this.contractOptions.forEach(contract => {
          if (newVal.value.contract === contract.value) {
            this.contract = contract
          }
        })
      }
    },
  },
  methods: {
    checkBoxChecked(value) {
      this.users = this.users.map(user => ({ ...user, selected: value }))
    },
    setDate(date, slot) {
      if (slot === 'start') {
        [this.from] = date
      }
      if (slot === 'end') {
        /* eslint-disable no-param-reassign */
        [this.to] = date
        this.to.setHours(23, 59, 59, 0)
      }
      if (this.from < this.to) {
        fetchShifts({ from: this.from, to: this.to, isQuickShift: this.isQuickShift })
          .then(async response => {
            const userIds = []
            const shiftsMap = []
            this.user = []
            response.forEach(shift => {
              if (shift.assignedTo) {
                const id = shift.assignedTo
                if (userIds.indexOf(id) === -1) {
                  userIds.push(id)
                  shiftsMap[id] = [shift]
                } else {
                  shiftsMap[id].push(shift)
                }
              }
            })
            try {
              this.users = await Promise.all(userIds.map(async id => {
              const user = await fetchUser({ id })
              const isUserNew = await isUserNewToPayroll({ id, start: new Date() })
              user.isUserNew = isUserNew
              return user
              }))
              // Match shifts with users
              this.users.forEach(user => {
                /* eslint-disable no-param-reassign */
                const shifts = shiftsMap[user.id]
                user.shifts = shifts
                user.selected = true
                /* eslint-enable */
              })
            } catch (error) {
              this.$emit('error')
            }
          })
          .catch(() => {
            this.$emit('error')
          })
      }
    },

    // fetchShifts(from, to) {
    // },
    onModalOpen() {},
    resetModal() {
      this.from = null
      this.to = null
      this.fromStr = ''
      this.toStr = ''
      this.users = []
      this.allSelected = true
    },
    async handleCreate() {
      const selectedUsers = this.users.filter(user => user.selected)
      let shiftList = []
      selectedUsers.forEach(selectedUser => {
        const { shifts, ...user } = selectedUser
        shiftList = [...shiftList, ...shifts.map(s => ({ ...s, user }))]
      })
      const payrollList = await createPayrolls(
        shiftList,
        true,
        {
          from: this.from,
          to: this.to,
        },
      )
      await savePayrolls(payrollList)
      this.$emit('created')
    },
  },
}
</script>

<style lang="scss">
@import '@hw-ui/scss/vue/libs/vue-flatpicker.scss';
</style>
